import React, { useState, useEffect, useRef } from 'react';
import { AnalyticsEvents } from '../services/analytics';
import './ConnectionErrorBanner.css';

const ConnectionErrorBanner: React.FC = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);
  const offlineStartTime = useRef<number | null>(null);

  useEffect(() => {
    const handleOnline = () => {
      setIsOffline(false);
      // Track restauración de conexión
      if (offlineStartTime.current) {
        const duration = Date.now() - offlineStartTime.current;
        AnalyticsEvents.connectionRestored();
        offlineStartTime.current = null;
      }
      // Mantener el mensaje por un momento después de reconectar para que el usuario lo vea
      setTimeout(() => {
        setWasOffline(false);
      }, 2000);
    };

    const handleOffline = () => {
      setIsOffline(true);
      setWasOffline(true);
      offlineStartTime.current = Date.now();
      // Track error de conexión
      AnalyticsEvents.connectionError();
    };

    // Verificar estado inicial
    if (!navigator.onLine) {
      setIsOffline(true);
      setWasOffline(true);
    }

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!isOffline && !wasOffline) {
    return null;
  }

  return (
    <div className={`connection-error-banner ${isOffline ? 'offline' : 'reconnected'}`}>
      <div className="connection-error-content">
        <span className="connection-error-icon">
          {isOffline ? '⚠️' : '✓'}
        </span>
        <span className="connection-error-text">
          {isOffline 
            ? 'Error de conexión. Algunas funcionalidades podrían tener inconvenientes.'
            : 'Conexión restablecida'}
        </span>
      </div>
    </div>
  );
};

export default ConnectionErrorBanner;
